import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../design/tokens';
import { SocialSettings } from '../../types';
import { FiSave, FiShare2 } from 'react-icons/fi';

const Section = styled.section`
  background: ${tokens.colors.adminSurface};
  border-radius: 12px;
  padding: ${tokens.spacing.lg};
  margin-bottom: ${tokens.spacing.lg};
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${tokens.spacing.lg};
  padding-bottom: ${tokens.spacing.sm};
  border-bottom: 1px solid ${tokens.colors.adminBorder};
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.md};
`;

const SocialForm = styled.div`
  padding: ${tokens.spacing.lg};
`;

const FormGroup = styled.div`
  margin-bottom: ${tokens.spacing.xl};
`;

const FormLabel = styled.label`
  display: block;
  font-weight: 600;
  color: ${tokens.colors.adminText};
  margin-bottom: ${tokens.spacing.sm};
`;

const FormInput = styled.input`
  width: 100%;
  padding: ${tokens.spacing.md};
  border: 1px solid ${tokens.colors.adminBorder};
  border-radius: 6px;
  font-size: 14px;
  background: ${tokens.colors.adminSurface};
  color: ${tokens.colors.adminText};
  &:focus {
    outline: none;
    border-color: ${tokens.colors.adminAccent};
  }
`;

const FormActions = styled.div`
  display: flex;
  gap: ${tokens.spacing.md};
  justify-content: flex-end;
  margin-top: ${tokens.spacing.xl};
`;

const SaveBtn = styled.button`
  background: ${tokens.colors.adminAccent};
  color: white;
  border: none;
  padding: ${tokens.spacing.md} ${tokens.spacing.xl};
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.sm};
  &:hover {
    background: #7a04b8;
  }
`;

interface AdminSocialSettingsProps {
  settings: Partial<SocialSettings>;
  onUpdate: (settings: Partial<SocialSettings>) => void;
  onSave: () => void;
}

const AdminSocialSettings: React.FC<AdminSocialSettingsProps> = ({ settings, onUpdate, onSave }) => {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          {React.createElement(FiShare2 as any, { size: 24 })}
          Redes Sociales
        </SectionTitle>
      </SectionHeader>
      <SocialForm>
        <FormGroup>
          <FormLabel>Facebook URL</FormLabel>
          <FormInput
            type="url"
            value={settings.facebook_url || ''}
            onChange={(e) => onUpdate({ ...settings, facebook_url: e.target.value })}
            placeholder="https://facebook.com/tu-pagina"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Twitter URL</FormLabel>
          <FormInput
            type="url"
            value={settings.twitter_url || ''}
            onChange={(e) => onUpdate({ ...settings, twitter_url: e.target.value })}
            placeholder="https://twitter.com/tu-perfil"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Instagram URL</FormLabel>
          <FormInput
            type="url"
            value={settings.instagram_url || ''}
            onChange={(e) => onUpdate({ ...settings, instagram_url: e.target.value })}
            placeholder="https://instagram.com/tu-perfil"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>YouTube URL</FormLabel>
          <FormInput
            type="url"
            value={settings.youtube_url || ''}
            onChange={(e) => onUpdate({ ...settings, youtube_url: e.target.value })}
            placeholder="https://youtube.com/c/tu-canal"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>LinkedIn URL</FormLabel>
          <FormInput
            type="url"
            value={settings.linkedin_url || ''}
            onChange={(e) => onUpdate({ ...settings, linkedin_url: e.target.value })}
            placeholder="https://linkedin.com/in/tu-perfil"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>GitHub URL</FormLabel>
          <FormInput
            type="url"
            value={settings.github_url || ''}
            onChange={(e) => onUpdate({ ...settings, github_url: e.target.value })}
            placeholder="https://github.com/tu-usuario"
          />
        </FormGroup>

        <FormActions>
          <SaveBtn onClick={onSave}>
            {React.createElement(FiSave as any, { size: 16 })}
            Guardar Cambios
          </SaveBtn>
        </FormActions>
      </SocialForm>
    </Section>
  );
};

export default AdminSocialSettings;
